import { createGlobalStyle } from "styled-components";
import {
  background,
  border,
  content,
  dominant,
  message,
  prettyScrollbars,
} from "@glossy";

const RadarlyCardsMdEditorStyle = createGlobalStyle`
  .wmde-markdown.wmde-markdown,
  .wmde-markdown-var.wmde-markdown-var {
    --color-fg-default: ${content};
    --color-accent-fg: ${dominant};
    --color-fg-muted: ${(p) => content(p, "secondary")};
    --color-prettylights-syntax-constant: ${dominant};
    --color-prettylights-syntax-markup-deleted-text: ${(p) =>
      message(p, "error")};
    --color-prettylights-syntax-markup-bold: ${content};
    --color-prettylights-syntax-comment: ${(p) => content(p, "secondary")};
    --color-canvas-default: ${background};
    --color-border-default: ${border};
    --color-border-muted: ${(p) => content(p, "secondary")};
    
    hr { flex-shrink: 0; height: 1px; }
    ol { list-style: decimal outside; }
    ul { list-style: disc outside; }
    em { font-style: italic; }
    a { text-decoration: underline; }
    h2 { border-bottom: 0; }

    &.w-md-editor-show-preview {
      box-shadow: none;
    }
  }

  .w-md-editor-preview {
    padding: 0;
    margin: 0;
    ${prettyScrollbars};
  }
  
  .w-md-editor-aree {
    ${prettyScrollbars};
  }
`;

export default RadarlyCardsMdEditorStyle;
